import React from 'react';
import { Grid, Typography } from '@mui/material';
import ProductCard from './ProductCard';

const ProductsGrid = ({ products }) => {
  if (!Array.isArray(products)) {
    return <Typography>Товары не найдены или произошла ошибка загрузки.</Typography>;
  }

  return (
    <Grid container spacing={2}>
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
        />
      ))}
    </Grid>
  );
};

export default ProductsGrid;
